import config from '../config'

const imgBaseUrl = config.firebase.getImageUrl()

export const events = {
    ids: [
        "F20220101"
    ],
    // 2022 新年新希望集資公益減脂賽
    F20220101: {
        title: "2022 新年新希望集資公益減脂賽",
        titleMobile: `2022 
        - 新年新希望 -
        集資公益減脂賽`,
        subTitle: `Let's play FitGames！用運動支持帕奧選手！`,
        subTitleMobile: `Let's play FitGames！
        用運動支持帕奧選手！`,
        backgroundImgUrl: `${imgBaseUrl}/Events%2FF20220101%2FBG_F20220101.jpg?alt=media`,
        backgroundMobileImgUrl: `${imgBaseUrl}/Events%2FF20220101%2FBG_F20220101_Mobile.jpg?alt=media`,
        headerLogoImgUrl: `${imgBaseUrl}/Events%2FF20220101%2Flogo_ctsod.png?alt=media`,
        headerLogoWhiteImgUrl: `${imgBaseUrl}/Events%2FF20220101%2Flogo_ctsod_white.png?alt=media`,
        description: {
            title: "教練！我要減脂3％UP！",
            titleMobile: `教練！
            我要減脂3％UP！`,
            subTitle: `手把手專業輔導＆集資做公益
            「挑戰成功」可均分捐贈公益後之總獎池金`,
            content1: `減重很簡單但減脂超難？減掉的到底是水分還是脂肪？減脂好難懂聽攏無......沒關係！
            加入公益集資健身賽，讓你健康問題有解答！運動不受傷！`,
            content2: `我們一起運動許願集氣 ！新的一年給自己一個健康的BODY ！`,
            content2Mobile: `我們一起運動許願集氣 ！
            新的一年給自己一個健康的BODY ！`,
        },
        rewards: {
            title: "冠軍隊獎金新台幣",
            titleNumber: "$20,000!",
            titleMobile: `冠軍隊獎金
            新台幣$20,000!`,
            subTitle: "報名還有小禮物唷",
            content: `透過FitGames線上教戰，減脂變得好好玩！挑戰不受時間及場地限制，
            下載FitGames APP報名參加，每週固定運動。
            年後挑戰五週減掉3%體脂，挑戰成功者能賺獎金。
            
            FitGames最好玩的健身遊戲，讓您邊玩健身又賺獎金同時支持公益；
            揪團組隊挑戰玩，冠軍隊還加碼獎金均分新台幣兩萬元，
            新年減脂不孤單  一起送給自已最健康的禮物！`,
            contentMobile: `透過FitGames線上教戰，減脂變得好好玩！挑戰不受時間及場地限制，下載FitGames APP報名參加，每週固定運動。年後挑戰五週減掉3%體脂，挑戰成功者能賺獎金。
            
            FitGames最好玩的健身遊戲，讓您邊玩健身又賺獎金同時支持公益；揪團組隊挑戰玩，冠軍隊還加碼獎金均分新台幣兩萬元，新年減脂不孤單  一起送給自已最健康的禮物！`,
        },
        welfare: {
            title: "公益回饋",
            content: "FitGames讓您減脂成功又賺獎金，同時兼具捐錢做公益 ，此次活動總報名費之三分之一將捐贈 「中華民國殘障體育運動總會」作為支持國家帕奧選手基金，用於身心障礙各種運動訓練、研究、選手制度、培訓計畫等，以推展肢障、視障、聽障、智障及其他身心障礙者各項體育運動，激發其生理潛能，使能積極參與社會活動及國際運動競賽。",
        },
        duration: `2022/2/12(六)-3/20(日)，
        於FitGames上傳並完成指定任務`,
        leaderBoard: {
            opening: `2022-02-22`,
            link: `https://www.facebook.com/Fitgamestw/`,
        },
        teams: {
            title: `全台健身品牌百位「健身教練」及「中華帕奧國手」成為您的專屬隊長`,
            content: `減重很簡單但減脂超難？減掉的到底是水分還是脂肪？減脂好難懂聽攏無..............沒關係！            
            只要選擇加入FitGames下列最優質的教練隊伍組隊報名，不但線上減脂問題有解答，線下團練運動又能不受傷，新年減脂不孤單又能獎金加碼賺喲~`,
            leaders: [
                {
                    name: `方振宇 羽球國手`,
                    team: `中華民國殘障體育運動總會隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_1.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG202201076599`,
                },
                {
                    name: `林姿妤 桌球國手`,
                    team: `中華民國殘障體育運動總會隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_2.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG202201077013`,
                },
                {
                    name: `田曉雯 桌球國手`,
                    team: `中華民國殘障體育運動總會隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_3.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG202201076883`,
                },
                {
                    name: `陳千霏 桌球國手`,
                    team: `中華民國殘障體育運動總會隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_4.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG202201077090`,
                },
                {
                    name: `彭宇暉 教練`,
                    team: `要動健身隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_5.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG202201075207`,
                },
                {
                    name: `威皓Max 教練`,
                    team: `Boss健身隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_6.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG202201075420`,
                },
                {
                    name: `SnooBy 教練`,
                    team: `SWAG思偉格隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_7.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG202201075404`,
                },
                {
                    name: `湯圓圓 教練`,
                    team: `妮飛健身隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_8.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG202201074881`,
                },
                {
                    name: `李昇龍 教練`,
                    team: `MOHO健身隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_9.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG202201064774`,
                },
                {
                    name: `雅各 教練`,
                    team: `悠健身隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_10.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG202201063535`,
                },
                {
                    name: `王秉和 教練`,
                    team: `98健身隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_11.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG202201082818`,
                },
                {
                    name: `小魁Matt 教練`,
                    team: `All Punch Studio隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_12.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG202201063057`,
                },
                {
                    name: `林侑霖 Yoly 教練`,
                    team: `塔索肌力隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_13.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG202201062879`,
                },
                {
                    name: `Luke 教練`,
                    team: `窩伴健身隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_14.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG20220108995`,
                },
                {
                    name: `阿懋Neil 教練`,
                    team: `自主訓練隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_15.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG20220108390`,
                },
                {
                    name: `安 教練`,
                    team: `自由教練隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_16.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG20220106910`,
                },
                {
                    name: `兆翔 教練`,
                    team: `自由教練隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_17.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG20220106782`,
                },
                {
                    name: `小新 教練`,
                    team: `自由教練隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_18.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG202201083570`,
                },
                {
                    name: `銘澤 教練`,
                    team: `自由教練隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_19.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG202201081355`,
                },
                {
                    name: `阿甫 教練`,
                    team: `自由教練隊`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fleader_20.png?alt=media`,
                    link: `https://fitgames-client.web.app/game?gid=FG202201069344`,
                },
            ],
        },
        host: {
            hostIconUrl: `${imgBaseUrl}/Events%2FF20220101%2Flogo_ctsod.png?alt=media`,
            description: "支持運動員是我們能為台灣運動產業所做的改變，一起用愛心集氣！",
            durationMobile: `支持運動員是我們能為台灣運動產業所做的改變，
            一起用愛心集氣！`,
            imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Fimg_new_yaer.jpg?alt=media`,
            imgUrlMobile: `${imgBaseUrl}/Events%2FF20220101%2Fimg_new_yaer_mobile.jpg?alt=media`,
            hostLink: `https://www.ctsod.org.tw/`,
        },
        steps: {
            title: "線上減脂遊戲步驟",
            flowImgs: [
                {
                    title: "選擇隊伍",
                    titleMobile: `❶ 選擇隊伍`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Ficon_step1.png?alt=media`,
                    number: '\u2776',
                },
                {
                    title: "下載FitGames APP 報名繳費",
                    titleMobile: `❷ 下載FitGames APP 報名繳費`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Ficon_step2.png?alt=media`,
                    number: '\u2777',
                },
                {
                    title: `A 完成初始/最終體脂量測
                    B 每週上傳 3 筆運動紀錄&nbsp`,
                    titleMobile: `❸ 完成初始/最終體脂量測
                    &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp及每週上傳 3 筆運動紀錄`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Ficon_step3.png?alt=media`,
                    number: '\u2778',
                },
                {
                    title: "成功完賽",
                    titleMobile: `❹ 成功完賽`,
                    imgUrl: `${imgBaseUrl}/Events%2FF20220101%2Ficon_step4.png?alt=media`,
                    number: '\u2779',
                },
            ],
        },
        coOrganizer: {
            title: "協辦單位",
            imgUrls: `${imgBaseUrl}/Events%2FF20220101%2Fimg_co_organizer.png?alt=media`,
            imgUrlsMobile: `${imgBaseUrl}/Events%2FF20220101%2Fimg_co_organizer.png?alt=media`,
        },
        coOperativeUnit: {
            title: "協力單位",
            imgUrls: `${imgBaseUrl}/Events%2FF20220101%2Fimg_co_operative_unit.png?alt=media`,
            imgUrlsMobile: `${imgBaseUrl}/Events%2FF20220101%2Fimg_co_operative_unit_mobile.png?alt=media`,
        },
        products: {
            title: "公益活動限定 組合優惠",
            subTitle: "商品組合詳情請點案下方預購按鈕",
            subTitleMobile: `商品組合詳情請點案下方預購按鈕`,
            items: [
                `${imgBaseUrl}/Events%2FF20220101%2Fimg_product1.jpg?alt=media`,
                `${imgBaseUrl}/Events%2FF20220101%2Fimg_product2.jpg?alt=media`,
            ],
        },
    },
    blank: {
        title: "",
        titleMobile: "",
        subTitle: "",
        backgroundImgUrl: "",
        backgroundMobileImgUrl: "",
        headerLogoImgUrl: "",
        headerLogoWhiteImgUrl: "",
        description: {
            title: "",
            subTitle: "",
            content1: "",
            content2: "",
        },
        rewards: {
            title: "",
            subTitle: "",
            content: "",
        },
        welfare: {
            title: "",
            content: "",
        },
        duration: "",
        leaderBoard: "",
        teams: {
            title: "",
            content: "",
            leaders: [],
        },
        host: {
            title: "",
            subTitle: "",
            imgUrl: "",
        },
        steps: {
            title: "",
            flowImgs: [],
        },
        coOrganizer: {
            title: "協辦單位",
            imgUrls: [],
        },
        coOperativeUnit: {
            title: "協力單位",
            imgUrls: [],
        },
        products: {
            title: "",
            subTitle: "",
            items: [
                {
                    title: "",
                    subTitle: "",
                    imgUrl: "",
                },
                {
                    title: "",
                    subTitle: "",
                    imgUrl: "",
                },
            ],
        },
    }
}